console.log('PI FILE LOADED');
class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.data = {};
    this.productJSON();
    this.preloadData();
  }

  connectedCallback() {
    this.initSlider();
    this.initSelectedVariantl();
    this.bindGalleryClicks();
  }

  bindGalleryClicks() {
    const gallery = this.querySelector('.pin-gallery-swiper');
    if (!gallery) return;
    gallery.addEventListener('click', (e) => {
      const slide = e.target.closest('.swiper-slide');
      if (!slide) return;
      const slides = gallery.querySelectorAll('.swiper-slide');
      const clickedIndex = Array.from(slides).indexOf(slide);
      const thumbSlides = this.querySelectorAll('.pin-thumb-swiper .swiper-slide');
      const targetSlide = thumbSlides[clickedIndex];
      if (!targetSlide) return;
      const mediaId = targetSlide.dataset.mediaId;
      if (!mediaId) return;

      console.log('clicked index:', clickedIndex, 'mediaId:', mediaId, 'variants with media:', this.data.variants.map(v => ({id: v.id, o1: v.option1, mediaId: v.featured_media?.id})));

      // Try exact featured_media match first
      let variant = this.data.variants.find(v => v.featured_media?.id?.toString() === mediaId);

      // Fallback: find variant whose media array contains this mediaId
      if (!variant) {
        const currentVariant = this.getCurrentVariantFromURL();
        const currentSize = currentVariant?.option2 || this.data.variants[0]?.option2;
        // Find which color this image belongs to by checking all variants
        // and picking the one whose featured_media matches, keeping current size
        const colorMatch = this.data.variants.find(v => {
          return v.featured_media?.id?.toString() === mediaId;
        });
        if (colorMatch && currentSize) {
          variant = this.data.variants.find(v =>
            v.option1 === colorMatch.option1 && v.option2 === currentSize
          );
        }
      }

      if (!variant) {
        console.log('No variant found for mediaId:', mediaId);
        return;
      }

      this.updateURL(variant.id);
      const idInput = this.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      const picker = this.querySelector('.pin-variant-picker');
      if (picker) {
        picker.querySelectorAll('input[type="radio"]').forEach(input => {
          if (input.value === variant.option1 || input.value === variant.option2) {
            input.checked = true;
          }
        });
      }
      this.renderUI(variant);
    });
  }

  getCurrentVariantFromURL() {
    const variantId = new URLSearchParams(location.search).get("variant");
    return variantId ? this.getCurrentVariant(variantId) : null;
  }

  syncVariant() {
    const picker = this.querySelector('.pin-variant-picker');
    if (!picker) return;

    const allInputs = picker.querySelectorAll('input[type="radio"]');
    const optionMap = {};
    allInputs.forEach(input => {
      if (input.checked) {
        const pos = parseInt(input.name.replace('vo', '')) - 1;
        optionMap[pos] = input.value;
      }
    });

    console.log('syncVariant optionMap:', JSON.stringify(optionMap));

    const numOptions = Object.keys(optionMap).length;
    const variant = this.data.variants.find(v => {
      for (let i = 0; i < numOptions; i++) {
        if (v['option' + (i + 1)] !== optionMap[i]) return false;
      }
      return true;
    });

    console.log('matched variant:', variant?.id, variant?.option1, variant?.option2);

    if (variant) {
      this.updateURL(variant.id);
      const idInput = this.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      const slideIndex = this.getSlideByMediaId(variant.featured_media?.id);
      if (slideIndex >= 0) this.gotoSlide(slideIndex);
      this.renderUI(variant);
    }
  }

  updateURL(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    history.pushState({}, "", url.toString());
  }

  // Fetch a variant's page HTML on demand. Used when preloadData hasn't
  // completed by the time the user clicks a swatch. Caches the result on
  // variant.html so subsequent clicks use the same buffer as preloadData.
  async fetchVariantHtml(variant) {
    const url = `/products/${this.data?.product?.handle}?variant=${variant.id}`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      variant.html = html;
      return html;
    } catch (err) {
      console.error('fetchVariantHtml failed for variant', variant.id, err);
      return null;
    }
  }

  async renderUI(variant) {
    const idInput = this.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    // If preload hasn't finished yet, fetch on demand before swapping.
    // This is the critical fix — previously renderUI returned silently
    // when variant.html was undefined, leaving stale sold-out markup
    // from the initial page load in place.
    let html = variant?.html || null;
    if (!html) {
      html = await this.fetchVariantHtml(variant);
    }
    if (!html) return;

    if (this.querySelector(".pin-price") && html.querySelector(".pin-price")) {
      this.querySelector(".pin-price").innerHTML =
        html.querySelector(".pin-price").innerHTML;
    }

    if (this.querySelector(".pin-act-button-wrapper") && html.querySelector(".pin-act-button-wrapper")) {
      this.querySelector(".pin-act-button-wrapper").innerHTML =
        html.querySelector(".pin-act-button-wrapper").innerHTML;
    }
  }

  getCurrentVariant(variantId) {
    return this.data?.variants?.find((v) => v.id.toString() === variantId);
  }

  initSelectedVariantl() {
    let variantId = new URLSearchParams(location.search).get("variant");
    if (variantId) {
      let variant = this.getCurrentVariant(variantId);
      let slideIndex = this.getSlideByMediaId(variant?.featured_media?.id);
      if (slideIndex >= 0) {
        this.gotoSlide(slideIndex);
      }
    }
  }

  getSlideByMediaId(id) {
    let slides = this.querySelectorAll(".pin-thumb-swiper .swiper-slide");
    let index = null;
    slides.forEach((slide, i) => {
      if (slide.dataset?.mediaId === id?.toString()) {
        index = i;
      }
    });
    return index;
  }

  gotoSlide(index) {
    if (this.thumbSwiper) this.thumbSwiper.slideTo(index);
  }

  initSlider() {
    this.gallerySwiper = new Swiper(".pin-gallery-swiper", {
      slidesPerView: 5,
      spaceBetween: 10,
    });
    this.thumbSwiper = new Swiper(".pin-thumb-swiper", {
      slidesPerView: 1,
      autoHeight: true,
      thumbs: {
        swiper: this.gallerySwiper,
      },
    });
  }

  productJSON() {
    const jsonString = this.querySelector(
      'script[type="application/json-product"]'
    ).textContent;
    try {
      const productData = JSON.parse(jsonString);
      this.data.product = productData || {};
      this.data.variants = productData?.variants || [];
    } catch (err) {
      this.data.product = {};
      this.data.variants = [];
    }
  }

  preloadData() {
    if (this.data) {
      this.data?.variants?.map(async (variant) => {
        let url = `/products/${this.data?.product?.handle}?variant=${variant.id}`;
        const response = await fetch(url);
        const data = await response.text();
        const html = new DOMParser().parseFromString(data, "text/html");
        variant.html = html;
      });
    }
  }
}

if (!customElements.get('product-information')) {
  customElements.define("product-information", ProductInformation);
}